module.exports = __webpack_public_path__ + "99eaf70c83fbea8a14ecb62cffbbccf1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano_spelen.mp3
// module id = 107
// module chunks = 0